import { connect } from 'react-redux'
export {i18nState} from './reducer'
export {setLanguages, setLanguage, setNextLanguage, getLanguageInfos, getLanguageInfo, setTranslations, InitLanguage} from './actions'

export default connect(state => ({
  lang: state.i18nState.lang
}))



// WEBPACK FOOTER //
// ./src/app/language/index.js